module.exports = __webpack_public_path__ + "img/corriente_b_gray.b1128aed.svg";